/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Terms and Conditions View Model
    // Terms and Conditions Processing Information
    /**************************************/
    function TermsConditionsViewModel(termsType, container, masterModel) {

        // Self-Identification
        var self = this;
        var applicationViewModel = masterModel;

        /***  PROPERTIES ***/
        this.Title = ko.observable();
        this.TermsType = ko.observable(termsType);
        this.LocationID = ko.observable();
        this.UpdateData = ko.observable(false);
        this.TermsMessage = ko.observable("");
        this.sectionIncluded = ko.observable(false);
        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.Touched = ko.observable(false);
        this.DataContainer = ko.observable(container);
        this.DataLoadErrorCount = ko.observable(0);
        /*** SECTION PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.TermsList = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        /*** COMPUTED PROPERTIES ***/
        this.ShouldDisplay = ko.computed(function () {
            if (this.TermsList().length > 0) {
                return true;
            }

            return false;
        }, this);

        this.IsRequired = ko.computed(function () {
            var required = false;
            for (var i = 0; i < this.TermsList().length; i++) {
                if (this.TermsList()[i].IsRequired()) {
                    required = true;
                }
            }

            return required;

        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** METHODS ***/
        /*** METHODS ***/

        /*** SECTION METHODS ***/
        this.Initialize = function () {
        };
        this.LoadModel = function (container) {
            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData(termsType, container.Payload.Config);
            }
            this.TermsList(Array());

            if (container.Payload.TermsConditions != null) {

                for (var i = 0; i < container.Payload.TermsConditions.length; i++) {
                    var item = new sm.portal.vm.TermsConditionsDocumentViewModel(termsType);
                    item.LoadModel(container.Payload.TermsConditions[i]);
                    this.TermsList.push(item);
                }

                if (container.Payload.TermsConditions.length > 0) {
                    this.LocationID(container.Payload.TermsConditions[0].LocationID);
                }
            }

            if (container.Payload.TermsMessage != null) {
                this.TermsMessage(container.Payload.TermsMessage);
            }

            this.DataLoading(false);
            this.DataLoaded(true);
            this.UpdateData(false);

            if (applicationViewModel != null) {
                var sectionsToAdd = Array();
                var sectionsToRemove = Array();
                if (this.TermsList().length > 0) {
                    sectionsToAdd.push({ section: this.TermsType(), required: this.IsRequired() });
                }
                else {
                    sectionsToRemove.push(this.TermsType());
                }

                applicationViewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
            }

            if (smapi.constant.applicationDebugFlag) { console.log('[TermsConditionsComposedDocumentVM] Data Loaded'); }
        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
           
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    if(this.TermsType()=="BeforeTerms"){
                        self.LoadModel(viewModel.allCustomData().BeforeTerms);
                        callback && callback(viewModel.allCustomData().BeforeTerms);
                        return;
                    }
                    if(this.TermsType()=="AfterTerms"){
                        self.LoadModel(viewModel.allCustomData().AfterTerms);
                        callback && callback(viewModel.allCustomData().AfterTerms);
                        return;
                    }
                }
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName={1}&attemptmid={0}', applicationMID, this.TermsType());

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };
        this.CheckInclusion = function (applicationMID, personMID) {
            if(self.sectionIncluded()) return;
            
            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName={1}&attemptmid={0}', applicationMID, this.TermsType());

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    self.sectionIncluded(true);
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for ' + self.TermsType() + ': ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: self.TermsType(), required: self.IsRequired() });
                                self.UpdateData(true);
                                self.DataLoading(false);
                                self.DataLoaded(false);
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: self.TermsType(), required: self.IsRequired() });
                                break;
                            case "Exclude":
                                sectionsToRemove.push(self.TermsType());
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        applicationViewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };
        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            var termsHistory = Array();

            if (this.TermsList().length > 0) {
                for (var i = 0; i < this.TermsList().length; i++) {
                    var termDocument = this.TermsList()[i];
                    if (termDocument.Paragraphs().length > 0) {
                        for (var j = 0; j < termDocument.Paragraphs().length; j++) {
                            var termParagraph = termDocument.Paragraphs()[j];

                            var ato = new sm.portal.vm.TermsConditionsHistoryFacadeModel({
                                IsAccepted: termParagraph.Accepted(),
                                ProcessObjectID: 0,
                                ParagraphSortOrder: termParagraph.SortOrder(),
                                LocationID: this.LocationID(),
                                TermsConditionsDocumentID: termDocument.ID(),
                                TermsConditionsParagraphVersionID: termParagraph.ParagraphVersionID(),
                                PersonID: null,
                                ProcessTypeID: 0
                            });

                            termsHistory.push(ato);
                        }

                    }
                }
            }
            // [EXTEND] New fields added to view model need to be updated here
            return termsHistory;
        };
        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {

            var isCompleted = true;
            isCompleted = this.IsVMValid();

            if (isCompleted) {
                for (var i = 0; i < this.TermsList().length; i++) {
                    var term = this.TermsList()[i];
                    if (!term.Completed()) {
                        return false;
                    }
                }
            }

            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/


        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        TermsConditionsViewModel: TermsConditionsViewModel,
    });

})(jQuery);